export default {
    npi: '1760417232',
    providerType: 'PH'
}